const getEdge = ({
  el,
  side,
  ltr
}: {
  el: Element;
  side: 'leading' | 'trailing';
  ltr: boolean;
}): number => {
  const rect = el.getBoundingClientRect();

  if (side === 'leading') {
    return ltr ? rect.left : rect.right;
  }

  return ltr ? rect.right : rect.left;
};

export default getEdge;
